import React, { useState, FC } from "react";
import { Modal, Space, Row, Col, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { DeleteOutlined } from "@ant-design/icons";
import { DeleteWarehouse } from "../../api/warehouse";
import { deleteWarehouse } from "../../context/warehouse/warehouse.action";
import { useGlobalDispatch } from "../../context/Provider";

type DeleteWarehouseModalProps = {
  visible: boolean;
  setVisible: (value: boolean) => void;
  info: object;
  setInfo: (value: object) => void;
};

const DeleteWarehouseModal: FC<DeleteWarehouseModalProps> = (props) => {
  const { visible, setVisible, info, setInfo } = props;
  const { Title, Text } = Typography;
  const { name, id }: any = info;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { warehouserListDispatch: dispatch }: any = useGlobalDispatch();

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    DeleteWarehouse(id).then((res: any) => {
      setVisible(false);
      setConfirmLoading(false);
      if (res.status === 204) {
        dispatch(deleteWarehouse({ id }));
        setInfo({});
      }
    });
  };
  return (
    <Modal
      closable={false}
      visible={visible}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
    >
      <Row gutter={[24, 24]}>
        <Col xs={{ span: 12, offset: 10 }}>
          <DeleteOutlined style={{ fontSize: "55px", color: "#D82148" }} />
        </Col>

        <Col span={24}>
          <Space style={{ alignItems: "center" }}>
            <Title level={4} style={{ marginBottom: 0 }}>
              <FormattedMessage id="warehouse.deleteWarehouse" />
            </Title>
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Text>
              <FormattedMessage id="warehouse.name" />
            </Text>
            :<Text type="secondary">{name}</Text>
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};

export default DeleteWarehouseModal;
